import { useParams } from "@tanstack/react-router";
import { VenueDetailsFallback } from "./VenueDetailsFallback";

export function VenueDetailsErrorBoundary() {
  const params = useParams({ strict: false }) as { venueId?: string };
  // Unlike the dataless render, this state never self-recovers — the user needs a way out.
  return <VenueDetailsFallback slug={params?.venueId ?? "venue"} showReload />;
}
